import React from 'react'
import Banner from "../About/Banner"


export default function Mission () {
    return (
            <div className="container-fluid test py-3">
                    <div className="row">
                        <div className="col-lg-6 mx-auto">
                            <Banner header="Our Mission"/>
                                <p>
                                Our mission as a manufacturing service (contract manufacturer) provider is very much aligned with our national industrial ministry’s
                                mission. We want to contribute to the goal of our nation to be a leading manufacturing hub for the world.
                                </p>
                        </div>
                        <div className="col-lg-6 mx-auto">
                            <Banner header="Our Vision"/>
                                <p>
                                Our vision is to be ranked on the top list of the manufacturing industries of our country.
                                </p>
                        </div>
                    
                    </div>
            </div>

    
    )
}

